import SegmentLogo from '@segment/matcha/components/SegmentLogo';
import * as Navbar from '@segment/matcha/recipes/Navigation/DesktopNavigation/Navbar';
import DesktopNavBase, * as DesktopNav from '@segment/matcha/recipes/Navigation/DesktopNavigation';
import { trackButtonClick } from '@segment/tracking/scripts';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return _jsxs(DesktopNavBase, {
    children: [announcement && _jsx(DesktopNav.UtilityNav, {
      announcement: announcement
    }), _jsx(DesktopNav.Navbar, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: _jsx(Navbar.Brand, {
        href: "/",
        onClick: function onClick() {
          return trackButtonClick({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: _jsx(SegmentLogo, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

export default MobileNavigation;